webpackJsonp([1],{

/***/ "1DTu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__("3EgV");
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.css
var dist_vuetify = __webpack_require__("QCv7");
var dist_vuetify_default = /*#__PURE__*/__webpack_require__.n(dist_vuetify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  data: function data() {
    return {
      drawer: null,
      menuItems: [{ icon: 'fa-newspaper-o', title: 'Blog', link: '/blog' }, { icon: 'fa-user', title: 'About Us', link: '/aboutus' }, { icon: 'fa-address-card-o', title: 'Contactform', link: '/contactme' }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ca5d1e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":""}},[_c('v-navigation-drawer',{attrs:{"temporary":"","dark":"","absolute":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',_vm._l((_vm.menuItems),function(item){return _c('v-list-tile',{key:item.title,attrs:{"router":"","to":item.link}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_vm._v(_vm._s(item.title))])],1)}),1)],1),_vm._v(" "),_c('v-toolbar',[_c('v-toolbar-side-icon',{staticClass:"hidden-sm-and-up",nativeOn:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',[_c('router-link',{staticStyle:{"cursor":"pointer"},attrs:{"to":"/","tag":"span"}},[_vm._v("Digital Tranquility")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-xs-only"},_vm._l((_vm.menuItems),function(item){return _c('v-btn',{key:item.title,attrs:{"flat":"","router":"","to":item.link}},[_c('v-layout',{attrs:{"justify-space-around":""}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v(_vm._s(item.icon))]),_vm._v("\n          "+_vm._s(item.title)+"\n        ")],1)],1)}),1)],1),_vm._v(" "),_c('main',[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/firebase/index.js
var firebase = __webpack_require__("Sazm");
var firebase_default = /*#__PURE__*/__webpack_require__.n(firebase);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Home.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Home = ({
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6883ab86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('section',[_c('v-parallax',{attrs:{"src":"static/img/thumb-1920-456498.jpg","height":"600"}},[_c('v-layout',{staticClass:"white--text",attrs:{"column":"","align-center":"","justify-center":""}},[_c('h1',{staticClass:"black--text mb-2 display-1 text-xs-center"},[_vm._v("Digital Tranquility")]),_vm._v(" "),_c('div',{staticClass:"black--text subheading mb-3 text-xs-center"},[_vm._v("Powered by T. Kerkhof")]),_vm._v(" "),_c('v-btn',{staticClass:"blue lighten-2 mt-5",attrs:{"dark":"","large":"","to":"aboutus"}},[_vm._v("\n           About us\n         ")])],1)],1)],1),_vm._v(" "),_c('section',[_c('v-layout',{staticClass:"my-5",attrs:{"column":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","sm4":""}},[_c('div',{staticClass:"text-xs-center"},[_c('h2',{staticClass:"headline"},[_vm._v("Go to bed with an eased state of mind")]),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v("\n             Knowing your IT is in good hands\n           ")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-icon',{staticClass:"blue--text text--lighten-2",attrs:{"x-large":""}},[_vm._v("flash_on")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Fast development")])]),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-center"},[_vm._v("\n                   First time right. Save money.\n                 ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-icon',{staticClass:"blue--text text--lighten-2",attrs:{"x-large":""}},[_vm._v("color_lens")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline text-xs-center"},[_vm._v("Allround Application Development")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n                   Proficiant in a varity of solutions ranging from Oracle Database 8, 9, 10, 11, 12c to Oracle Apex for rapid backend data entry and reporting, to lean and mean Node.js API's, to Vue.js.  \n                 ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-icon',{staticClass:"blue--text text--lighten-2",attrs:{"x-large":""}},[_vm._v("build")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline text-xs-center"},[_vm._v("10+ years experience")])]),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-center"},[_vm._v("\n                   Programming ever since I was wearing diapers. High quality and stable applications.\n                 ")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-parallax',{attrs:{"src":"static/img/alien_zen-wallpaper-1920x1080.jpg"}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline black--text mb-3 text-xs-center"},[_vm._v("Focus on your core business")]),_vm._v(" "),_c('em',{staticClass:"black--text"},[_vm._v("Leave your IT to the professionals")]),_vm._v(" "),_c('v-btn',{staticClass:"blue lighten-2 mt-5",attrs:{"dark":"","large":"","to":"blog"}},[_vm._v("\n           Blog\n         ")])],1)],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{staticClass:"my-5",attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Company info")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n               Digital Tranquility is situated in the old city center of Rijswijk (ZH). \n             ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","offset-sm1":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Contact us")])]),_vm._v(" "),_c('v-flex',{attrs:{"offset-sm3":""}},[_c('a',{attrs:{"href":"tel:+31655812339"}},[_c('v-icon',{staticClass:"text--lighten-2 pl-3"},[_vm._v("phone")])],1),_vm._v(" "),_c('a',{attrs:{"href":"https://api.whatsapp.com/send?phone=31655812339"}},[_c('v-icon',{staticClass:"green--text text--lighten-2 pl-3"},[_vm._v("fa-whatsapp")])],1),_vm._v(" "),_c('a',{attrs:{"href":"https://goo.gl/maps/8QUTChiiUZq"}},[_c('v-icon',{staticClass:"red--text text--lighten-2 pl-3"},[_vm._v("place")])],1),_vm._v(" "),_c('a',{attrs:{"href":"mailto:info@digitaltranquility.nl"}},[_c('v-icon',{staticClass:"dark--text text--lighten-2 pl-3"},[_vm._v("email")])],1),_vm._v(" "),_c('a',{attrs:{"href":"https://www.linkedin.com/in/digitaltranquility"}},[_c('v-icon',{staticClass:"blue--text text--lighten-2 pl-3"},[_vm._v("fa-linkedin")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/contactme'},"append":""}},[_c('v-icon',{staticClass:"yellow--text text--lighten-2 pl-3"},[_vm._v("fa-address-card-o")])],1)],1)],1)],1)],1)],1)],1)])}
var Home_staticRenderFns = []
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var components_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/components/Home.vue
function injectStyle (ssrContext) {
  __webpack_require__("1DTu")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = injectStyle
/* scopeId */
var Home___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  components_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var src_components_Home = (Home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Blog/Blog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Blog = ({
  name: 'Blog',
  data: function data() {
    return {
      imgUrl: '',
      date: '',
      content: '',
      title: 'Your Logo',
      dialog3: false,
      posts: [{
        id: 1,
        title: 'Off to a fresh start!',
        content: 'Digital Tranquility was officially launched today. Ive been playing with the idea to go freelance for quite some time now. This plus the fact I wanted to try and build a site with Vue.js made me take the leap. So this is it. Decided to start with a basic company section and a little blog.</br></br> If only I knew how to resize this avatar item. I look like a midget. Guess the component still needs some work. As a workaround back to GIMP for now ;)',
        imgUrl: '/static/img/blog/new_experience.jpg',
        date: '25-12-2017'
      }, {
        id: 2,
        title: 'About us / Projects section updated',
        content: 'Took a little stroll down memory lane and added a few more projects. Still needs some more in depth information, but we\'re getting there',
        imgUrl: '/static/img/blog/halfway.jpg',
        date: '29-12-2017'
      }]
    };
  },

  methods: {
    link: function link(title, socialMedium) {
      if (socialMedium === 'reddit') {
        window.open('http://www.reddit.com/submit?url=' + window.location.href + '&title=' + title);
      } else if (socialMedium === 'twitter') {
        window.open('https://twitter.com/intent/tweet?url=' + window.location.href + '&text=' + title + '&hashtags=DigitalTranquility');
      } else if (socialMedium === 'linkedin') {
        window.open('https://www.linkedin.com/shareArticle?mini=true&url=' + window.location.href + '&title=' + title);
      } else {
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + window.location.href + ' ' + title);
      }
    },
    itemClicked: function itemClicked(post) {
      this.id = post.id;
      this.title = post.title;
      this.content = post.content;
      this.imgUrl = post.imgUrl;
      this.date = post.date;
      this.dialog3 = true;
    }
  },
  filters: {
    truncate: function truncate(string, value) {
      return string.substring(0, value) + '...';
    }
  },
  computed: {
    reversePosts: function reversePosts() {
      return this.posts.slice().reverse();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3272ad2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Blog/Blog.vue
var Blog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-dialog',{attrs:{"max-width":"1000px"},model:{value:(_vm.dialog3),callback:function ($$v) {_vm.dialog3=$$v},expression:"dialog3"}},[_c('v-card',{staticClass:"my-3",attrs:{"hover":""}},[_c('v-card-media',{staticClass:"white--text",attrs:{"height":"500px","src":_vm.imgUrl}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('h1',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","offset-xs0":"","offset-md2":"","offset-lg7":""}},[_vm._v("\n                  "+_vm._s(_vm.date)+"\n                ")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.content)}})]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"blue--text text--darken-4",attrs:{"icon":""},on:{"click":function($event){return _vm.link( _vm.title, 'linkedin' )}}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v("fa-linkedin")])],1),_vm._v(" "),_c('v-btn',{staticClass:"light-blue--text",attrs:{"icon":""},on:{"click":function($event){return _vm.link( _vm.title, 'twitter' )}}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v("fa-twitter")])],1),_vm._v(" "),_c('v-btn',{staticClass:"red--text",attrs:{"icon":""},on:{"click":function($event){return _vm.link( _vm.title, 'reddit' )}}},[_c('v-icon',{staticStyle:{"cursor":"pointer"},attrs:{"medium":""}},[_vm._v("fa-reddit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"blue--text text--darken-4",attrs:{"icon":""},on:{"click":function($event){return _vm.link( _vm.title, 'facebook' )}}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v("fa-facebook")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.dialog3=false}}},[_vm._v("Close")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('div',{staticClass:"text-xs-center"},[_c('v-avatar',{staticClass:"mb-2",attrs:{"size":"175px"}},[_c('img',{staticClass:"img-circle elevation-6 mb-2",attrs:{"src":"/static/img/take.jpg"}})]),_vm._v(" "),_c('h4',[_vm._v("Take "),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Kerkhof")])]),_vm._v(" "),_c('h5',{staticClass:"text-xs-center"},[_vm._v("Developer, Father, Motorfanatic")])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md5":"","offset-md2":""}},_vm._l((_vm.reversePosts),function(post){return _c('div',{key:post.id},[_c('v-card',{staticClass:"my-3",attrs:{"hover":""}},[_c('v-card-media',{staticClass:"white--text",attrs:{"height":"170px","src":post.imgUrl}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(post.title))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","offset-xs0":"","offset-md2":"","offset-lg6":""}},[_vm._v("\n                    "+_vm._s(post.date)+"\n                  ")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm._f("truncate")(post.content,'200')))])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"blue--text text--darken-4",attrs:{"icon":""},on:{"click":function($event){return _vm.link( post.title, 'linkedin' )}}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v("fa-linkedin")])],1),_vm._v(" "),_c('v-btn',{staticClass:"light-blue--text",attrs:{"icon":""},on:{"click":function($event){return _vm.link( post.title, 'twitter' )}}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v("fa-twitter")])],1),_vm._v(" "),_c('v-btn',{staticClass:"red--text",attrs:{"icon":""},on:{"click":function($event){return _vm.link( post.title, 'reddit' )}}},[_c('v-icon',{staticStyle:{"cursor":"pointer"},attrs:{"medium":""}},[_vm._v("fa-reddit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"blue--text text--darken-4",attrs:{"icon":""},on:{"click":function($event){return _vm.link( post.title, 'facebook' )}}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v("fa-facebook")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"blue--text",attrs:{"flat":""},nativeOn:{"click":function($event){return _vm.itemClicked(post)}}},[_vm._v("Read More")])],1)],1)],1)}),0)],1)],1)],1)}
var Blog_staticRenderFns = []
var Blog_esExports = { render: Blog_render, staticRenderFns: Blog_staticRenderFns }
/* harmony default export */ var Blog_Blog = (Blog_esExports);
// CONCATENATED MODULE: ./src/components/Blog/Blog.vue
function Blog_injectStyle (ssrContext) {
  __webpack_require__("qUk0")
}
var Blog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Blog___vue_template_functional__ = false
/* styles */
var Blog___vue_styles__ = Blog_injectStyle
/* scopeId */
var Blog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Blog___vue_module_identifier__ = null
var Blog_Component = Blog_normalizeComponent(
  Blog,
  Blog_Blog,
  Blog___vue_template_functional__,
  Blog___vue_styles__,
  Blog___vue_scopeId__,
  Blog___vue_module_identifier__
)

/* harmony default export */ var components_Blog_Blog = (Blog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AboutUs/AboutUs.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var AboutUs = ({
  data: function data() {
    return {
      cards: [{ title: 'Bikesharing', subtitle: 'Mobile App & Backend application for bike maintenance - 5000+ users', src: '/static/img/bikesharing/bikesharing.jpg', text: 'For roughly a year I have helped in creating a bikesharing platform for a big bikesharing company in the Netherlands. This consist as both a backend system as well as the mobile app. The mobile app was created using cordova which loaded Oracle Apex in an iframe.</br> <img src="/static/img/bikesharing/bikefrontend.png"></img></br> This solution was a strategic choice of the company we worked for at the time. Oracle Apex was their main weapon of choice, hence the cordova - apex - iframe solution. It did offer some convenience: sometimes one could make due with a hotfix without having to release the app. If I was in the driver seat I would have chosen a different setup, but company wise I can respect the decision. Oracle Apexs mobile solution is jQuery mobile, also not ideal. To interface with the bikelocks, as payment method and location API we used Node.js.</br></br><img src="/static/img/bikesharing/bikebackend.png"></img></br>', show: false, chips: ['Node.js', 'Oracle Apex 5', 'Cordova', 'Oracle Database 12c', 'Google maps javascript API'] }, { title: 'Quality Control Application', subtitle: 'Managing inspection reports and certification - 10+ users', src: '/static/img/quality/maxresdefault.jpg', text: 'Responsible for the design and development of an application where the Quality department of a large freight company could manage their purchase orders and requisitions.', show: false, chips: ['Oracle Apex', 'Oracle Database 12c'] }, { title: 'Energy portal', subtitle: 'Customer portal to view energy usage, billing and reports - 1000+ users', src: '/static/img/energy/energie.jpg', text: 'For a company specialized in mainting and fixing energy infrastructure we made an energy portal. This offered customer to view their energy usage, bills and benchmark capabilities to see how their energy-usage relates to that of their compatitors. The fact that this companys clients were situated in one of the most competative garderning glass house argitectural regions, made this specially interesting. To displaying the data in a nice graphical way we used highcharts.js. An interactive javascript chart framework. Many of our users were companies specialized in energy advice.', show: false, chips: ['Highcharts.js', 'Oracle Apex', 'Oracle Database 12c'] }, { title: 'Calamaty Maintenance Application', subtitle: 'Customer portal to view energy usage, billing and reports - 100+ users', src: '/static/img/calamity/stroomstoring.jpg', text: 'In this application the company specialized in mainting and fixing energy infrastructure can register calamities on the grid. The questionaire is editable as is the flow of questions and status flows. The application is responsive, so the mechanics in the field could also use it on their tablet. Included integration with the device camera and reporting on the different statusses. This allows the company to monitor SLAs more closely. A restful interface was created with an external customer call center during out of office hours. Google maps integration to show active calamities.', show: false, chips: ['Oracle Apex', 'Restful Interface', 'Oracle Database 12c', 'Google maps javascript API'] }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b04bf9b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AboutUs/AboutUs.vue
var AboutUs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":"","offset-xs1":"","pb-1":""}},[_c('h1',[_vm._v("Projects")])]),_vm._v(" "),_vm._l((_vm.cards),function(card){return _c('v-flex',{key:card.title,attrs:{"xs8":"","offset-xs1":"","pb-3":""}},[_c('v-card',[_c('v-card-media',{attrs:{"src":card.src,"height":"550px"}}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(card.title))]),_vm._v(" "),_c('span',{staticClass:"grey--text"},[_vm._v(_vm._s(card.subtitle))])])]),_vm._v(" "),_vm._l((card.chips),function(chips){return _c('v-chip',{key:card.title},[_vm._v(_vm._s(chips))])}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){card.show = !card.show}}},[_c('v-icon',[_vm._v(_vm._s(_vm.show ? 'keyboard_arrow_down' : 'keyboard_arrow_up'))])],1)],1),_vm._v(" "),_c('v-slide-y-transition',[_c('v-card-text',{directives:[{name:"show",rawName:"v-show",value:(card.show),expression:"card.show"}],domProps:{"innerHTML":_vm._s(card.text)}})],1)],2)],1)})],2)}
var AboutUs_staticRenderFns = []
var AboutUs_esExports = { render: AboutUs_render, staticRenderFns: AboutUs_staticRenderFns }
/* harmony default export */ var AboutUs_AboutUs = (AboutUs_esExports);
// CONCATENATED MODULE: ./src/components/AboutUs/AboutUs.vue
var AboutUs_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AboutUs___vue_template_functional__ = false
/* styles */
var AboutUs___vue_styles__ = null
/* scopeId */
var AboutUs___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AboutUs___vue_module_identifier__ = null
var AboutUs_Component = AboutUs_normalizeComponent(
  AboutUs,
  AboutUs_AboutUs,
  AboutUs___vue_template_functional__,
  AboutUs___vue_styles__,
  AboutUs___vue_scopeId__,
  AboutUs___vue_module_identifier__
)

/* harmony default export */ var components_AboutUs_AboutUs = (AboutUs_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Login/Login.vue
//
//
//
//
//
//

/* harmony default export */ var Login = ({
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15d31e9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/Login.vue
var Login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n\tLogin\n")])}
var Login_staticRenderFns = []
var Login_esExports = { render: Login_render, staticRenderFns: Login_staticRenderFns }
/* harmony default export */ var Login_Login = (Login_esExports);
// CONCATENATED MODULE: ./src/components/Login/Login.vue
var Login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Login___vue_template_functional__ = false
/* styles */
var Login___vue_styles__ = null
/* scopeId */
var Login___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Login___vue_module_identifier__ = null
var Login_Component = Login_normalizeComponent(
  Login,
  Login_Login,
  Login___vue_template_functional__,
  Login___vue_styles__,
  Login___vue_scopeId__,
  Login___vue_module_identifier__
)

/* harmony default export */ var components_Login_Login = (Login_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContactMe/ContactMe.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* eslint-disable */
/* harmony default export */ var ContactMe = ({
  data: function data() {
    return {
      valid: true,
      name: '',
      nameRules: [function (v) {
        return !!v || 'Name is required';
      }],
      email: '',
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        );
      }],
      phone: '',
      checkbox: false
    };
  },
  methods: {
    resetForm: function resetForm() {
      this.form = assign_default()({}, this.defaultForm);
      this.$refs.form.reset();
    },
    submit: function submit() {
      var contactform = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        question: this.question
      };
      firebase["database"]().ref('contactform').push(contactform).then(function (data) {
        alert("You will be contacted shortly!");
      }).catch(function (error) {
        console.log('faal');
        console.log(error);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5928e7c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactMe/ContactMe.vue
var ContactMe_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"white--text",attrs:{"column":"","align-center":"","justify-center":""}},[_c('v-content',[_c('section',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":"Name","rules":_vm.nameRules,"required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"E-mail","rules":_vm.emailRules,"required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Phone","required":""},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Question","multi-line":""},model:{value:(_vm.question),callback:function ($$v) {_vm.question=$$v},expression:"question"}}),_vm._v(" "),_c('v-btn',{on:{"click":_vm.resetForm}},[_vm._v("clear")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid},on:{"click":_vm.submit}},[_vm._v("\n      submit\n    ")])],1)],1)])],1)}
var ContactMe_staticRenderFns = []
var ContactMe_esExports = { render: ContactMe_render, staticRenderFns: ContactMe_staticRenderFns }
/* harmony default export */ var ContactMe_ContactMe = (ContactMe_esExports);
// CONCATENATED MODULE: ./src/components/ContactMe/ContactMe.vue
var ContactMe_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ContactMe___vue_template_functional__ = false
/* styles */
var ContactMe___vue_styles__ = null
/* scopeId */
var ContactMe___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContactMe___vue_module_identifier__ = null
var ContactMe_Component = ContactMe_normalizeComponent(
  ContactMe,
  ContactMe_ContactMe,
  ContactMe___vue_template_functional__,
  ContactMe___vue_styles__,
  ContactMe___vue_scopeId__,
  ContactMe___vue_module_identifier__
)

/* harmony default export */ var components_ContactMe_ContactMe = (ContactMe_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Source/Source.vue
//
//
//
//
//
//

/* harmony default export */ var Source = ({
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d30f6fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Source/Source.vue
var Source_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n\tSource\n")])}
var Source_staticRenderFns = []
var Source_esExports = { render: Source_render, staticRenderFns: Source_staticRenderFns }
/* harmony default export */ var Source_Source = (Source_esExports);
// CONCATENATED MODULE: ./src/components/Source/Source.vue
var Source_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Source___vue_template_functional__ = false
/* styles */
var Source___vue_styles__ = null
/* scopeId */
var Source___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Source___vue_module_identifier__ = null
var Source_Component = Source_normalizeComponent(
  Source,
  Source_Source,
  Source___vue_template_functional__,
  Source___vue_styles__,
  Source___vue_scopeId__,
  Source___vue_module_identifier__
)

/* harmony default export */ var components_Source_Source = (Source_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js









vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_Home
  }, {
    path: '/blog',
    name: 'Blog',
    component: components_Blog_Blog
  }, {
    path: '/aboutus',
    name: 'AboutUs',
    component: components_AboutUs_AboutUs
  }, {
    path: '/login',
    name: 'Login',
    component: components_Login_Login
  }, {
    path: '/contactme',
    name: 'ContactMe',
    component: components_ContactMe_ContactMe
  }, {
    path: '/source.git',
    name: 'source.git',
    component: components_Source_Source
  }],
  mode: 'history'
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









vue_esm["a" /* default */].use(vuetify_default.a);

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: src_App },
  created: function created() {
    firebase["initializeApp"]({
      apiKey: 'AIzaSyBJ3nT8uI_T_jbwxB2uQFj_BCuiRXUjhro',
      authDomain: 'digitaltranquility-e86a1.firebaseapp.com',
      databaseURL: 'https://digitaltranquility-e86a1.firebaseio.com',
      projectId: 'digitaltranquility-e86a1',
      storageBucket: 'digitaltranquility-e86a1.appspot.com'
    });
  }
});

/***/ }),

/***/ "QCv7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qUk0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.5ca73b46cd0a3a763352.js